import React, { Component } from 'react';
import { connect } from 'react-redux';

const BRAND = '#6C5DD3';
const BRAND_LIGHT = '#F5F4FF';
const BRAND_BORDER = '#E5E9FE';
const TEXT_PRIMARY = '#0F0B28';
const TEXT_SECONDARY = '#585969';
const TEXT_MUTED = '#A5A6BB';
const BORDER = '#E3E3E3';

const th = {
  padding: '6px 10px',
  fontSize: '10px',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color: TEXT_SECONDARY,
  background: BRAND_LIGHT,
  borderBottom: `1px solid ${BRAND_BORDER}`,
  whiteSpace: 'nowrap',
};

const td = {
  padding: '6px 10px',
  fontSize: '12px',
  color: TEXT_PRIMARY,
  borderBottom: `1px solid #F5F5F5`,
};

class PharmacyCart extends Component {
  renderCartItems() {
    const { orderDetails } = this.props;
    if (!orderDetails || orderDetails.length === 0) {
      return (
        <tr>
          <td colSpan={7} style={{ ...td, textAlign: 'center', color: TEXT_MUTED, padding: '24px' }}>
            No items in cart
          </td>
        </tr>
      );
    }
    return orderDetails.map((medicine, index) => (
      <tr key={index} style={{ background: index % 2 === 0 ? '#fff' : '#FAFAFA' }}>
        <td style={{ ...td, color: TEXT_MUTED, fontWeight: 600 }}>{index + 1}</td>
        <td style={{ ...td, fontWeight: 600 }}>{medicine.drugName}</td>
        <td style={td}>₹{medicine.MRP}</td>
        <td style={{ ...td, color: '#1eb865', fontWeight: 600 }}>₹{medicine.discountedPrice}</td>
        <td style={{ ...td, textAlign: 'center' }}>{medicine.quantity}</td>
        <td style={td}>₹{medicine.totalMrp}</td>
        <td style={{ ...td, fontWeight: 700, color: BRAND }}>₹{medicine.cost}</td>
      </tr>
    ));
  }

  render() {
    const { orderAmount } = this.props;

    const paymentFields = [
      { label: 'User Paid', value: orderAmount?.amount != null ? `₹${orderAmount.amount}` : '—', color: '#EB5757' },
      { label: 'Wallet Deduction', value: orderAmount?.walletDeduction != null ? `₹${orderAmount.walletDeduction}` : '—', color: BRAND },
      { label: 'Total Amount', value: orderAmount?.totalAmount != null ? `₹${orderAmount.totalAmount}` : '—', color: '#1eb865' },
      { label: 'Order Type', value: orderAmount?.orderType || '—', color: TEXT_SECONDARY },
    ];

    return (
      <div>
        {/* Cart Table */}
        <div style={{ marginBottom: '10px' }}>
          <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.8px', color: TEXT_MUTED, marginBottom: '10px' }}>
            Cart Items
          </div>
          <div style={{ border: `1px solid ${BORDER}`, borderRadius: '6px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['#', 'Medicine Name', 'MRP', 'Discounted Price', 'Qty', 'Total MRP', 'Cost'].map(h => (
                    <th key={h} style={th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>{this.renderCartItems()}</tbody>
            </table>
          </div>
        </div>

        {/* Payment Detail */}
        <div>
          <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.8px', color: TEXT_MUTED, marginBottom: '6px' }}>
            Payment Breakdown
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1px', background: BORDER, border: `1px solid ${BORDER}`, borderRadius: '6px', overflow: 'hidden' }}>
            {paymentFields.map(({ label, value, color }) => (
              <div key={label} style={{ background: '#FAFAFA', padding: '8px 14px', flex: '1', minWidth: '100px' }}>
                <div style={{ fontSize: '10px', color: TEXT_MUTED, fontWeight: 600, marginBottom: '2px' }}>{label}</div>
                <div style={{ fontSize: '14px', fontWeight: 700, color }}>{value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
export default connect(mapStateToProps)(PharmacyCart);
